import React, { useState, useEffect } from "react";
import career1 from '../../assets//freepik-career-1.jpeg';
import career2 from '../../assets/freepik-career-2.jpeg';
import career3 from '../../assets/freepik-career-3.jpeg';
import { Box, Typography } from "@mui/material"; // Import MUI components

const CareerSlider = (props) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Array of cards with background images
  const cards = [
    { id: 1, header: "Your Vision, Our Expertise", imageUrl: career1 }, 
    { id: 2, header: "Innovative Services for a Digital Future", imageUrl: career2 }, 
    { id: 3, header: "Your Vision, Our Expertise", imageUrl: career3 },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === cards.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000); // Change slide every 3 seconds

    return () => clearInterval(interval);
  }, [cards.length]);

  return (
    <Box className="second-slider-container"  sx={{ width:"100%", height:"100%",overflow: "hidden", margin: "0 auto" }}>
      <Box
        className="second-slider-wrapper"
        sx={{
          display: "flex",
          transition: "transform 0.5s ease-in-out",
          transform: `translateX(-${currentIndex * 100}%)`,
        }}
      >
        {cards.map((card) => (
          <Box 
            key={card.id} 
            sx={{
              minWidth: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              position: "relative", // Allow positioning of text over the image
            }}
          >
            <Box 
              component='img' 
              src={card.imageUrl}
              sx={{
                width: '100%',
                objectFit: 'cover',
                maxHeight: { xs: '250px', sm: '250px', md: '300px', lg: '300px' }, // Responsive height
              }}
            />
            <Box 
              sx={{
                position: "absolute",
                bottom: "5%",
                left: "50%",
                transform: "translateX(-50%)", // Center text
                textAlign: "center",
                color: "white",
                padding: "0px", // Optional padding
                backdropFilter: "blur(5px)", // Optional blur effect for text background
              }}
            >
              <Typography variant="h4" sx={{ fontWeight: "bold",fontFamily:"poppins, sans-serif " ,fontSize:{
                xs:"1rem",
                sm:"1.8rem"
              }}}>
                {card.header}
              </Typography>
              <Typography variant="body1">
                {card.content}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CareerSlider;
